import "../styles/App.scss";
import { Outlet } from "react-router-dom";
// import { pageCountAtom } from "../App";
// import { useAtom } from "jotai";

function Root() {
  // Count pages WIP
  // const [{ pagePaths }] = useAtom(pageCountAtom);
  // const pageCount = pagePaths.length;

  return (
    <div className="form-app">    
      <div id="MainContentArea" className="container pt-6 md:pt-12 pb-6">
        <div id="MainContentArea" className="max-w-3xl">
          <>
            <h1 className="">Överklaga tilläggsavgift</h1>
            {/* {pageCount} */}
            <Outlet />
          </>
        </div>
      </div>

    </div>
  );
}

export default Root;
